export default __webpack_public_path__ + "static/media/sneakerNFTBgTbl2.8773bb9f.png";